import React from "react";
import img1 from "../img/screenshots/auburn1.png";
import img2 from "../img/screenshots/orlando1.png";
import img3 from "../img/screenshots/orlando2.png";
import img4 from "../img/screenshots/sanfrancisco1.png";
import img5 from "../img/screenshots/sanfrancisco2.png";
import img6 from "../img/screenshots/sanfrancisco3.png";
import img7 from "../img/screenshots/sanfrancisco4.png";
import img8 from "../img/screenshots/sanfrancisco5.png";

class DivsPatterns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImageUrl: img3,
      images: [img1, img2, img3, img4, img5, img6, img7, img8]
    };
  }
  componentDidMount() {
    var randomNumber = Math.floor(Math.random() * this.state.images.length);
    this.setState({ selectedImageUrl: this.state.images[randomNumber] });
  }

  render() {
    return (
      <main className="container-fluid col-md-11">
        <div className="row no-gutter">
          <div
            className="d-none d-md-flex col-md-4 col-lg-6 bg-image"
            style={{
              backgroundImage: "url(" + this.state.selectedImageUrl + ")"
            }}
          />
          <div className="col-md-8 col-lg-5 ml-5">
            <div className="login d-flex align-items-center py-5">
              <div className="container">
                <div className="row">
                  <div className={"col-md-9 col-lg-8 mx-auto " + (this.props.className ? this.props.className : "")}>
                    <h3 className="login-heading mb-4">
                      {this.props.headerText}
                    </h3>
                    {this.props.children}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default DivsPatterns;
